import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { JwtService } from 'src/app/core/services/jwt.service';
import { UserService } from 'src/app/core/services/user.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {
  // version = env.environment.version

  isMobileView: boolean = false;
  workPASStokenExist: boolean = false;
  userToken: any;
  userID: any;
  isProfileComplete: boolean = false;
  userData: any;

  hideApplyButton: any;

  constructor(private router: Router, private jwt: JwtService, private userService: UserService, private route: ActivatedRoute) { }

  ngOnInit(): void {

    this.userData = JSON.parse(localStorage.getItem("applicantDetails"));

    this.checkIfMobileView();

    // Subscribe to window resize events to update isMobileView dynamically
    window.addEventListener("resize", () => {
      this.checkIfMobileView();
    });

    this.userToken = this.jwt.getToken();
    this.jwt.getToken() ? this.workPASStokenExist = true : this.workPASStokenExist = false;
    this.userID = localStorage.getItem("userID");
    this.userService.getApplicantDetails(this.userID).subscribe((res) => {
      this.userData = res;
    },
    (error) => {
      this.userData = ""
    });
  }

  onNavigateLogin() {

    this.router.navigate(["login"]);

  }

  onNavigateDashboard() {
    if(this.userData.isProfileComplete == true){
    this.router.navigate(["user/home"]);
    } else {
      this.router.navigate(["/user/applicant-profilling"]);
    }
  }

  isLoginPage(): boolean {
    return this.router.url === '/login';
  }
  
  checkIfMobileView() {
    if ((this.isMobileView = window.innerWidth < 768)) {
      this.isMobileView = true;
    } else {
      this.isMobileView = false;
    }
  }
}
